module.exports = __webpack_public_path__ + "static/media/linkedin-icon.d9049f46.svg";